import React, { useContext } from "react";
import { HotelContext } from "../../context/HotelContext";
import { translate } from "../../utils/Translation";

const RewardsDetailsModal = ({ selectedReward, setSelectedReward, mapRewardTypeLabel }) => {
  const { lang } = useContext(HotelContext);

  if (!selectedReward) return null;

  return (
    <div
      className="rewards-list__modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-label={translate("v2_rewards_modal_details_aria", lang, { name: selectedReward.name })}
      onClick={() => setSelectedReward(null)}
    >
      <div className="rewards-list__modal" onClick={(e) => e.stopPropagation()}>
        <div className="rewards-list__modal-header">
          <div className="rewards-list__modal-title-wrap">
            <div className="rewards-list__modal-title">{selectedReward.name}</div>
            <div className="rewards-list__modal-subtitle">
              {mapRewardTypeLabel(selectedReward.rwType)} • {selectedReward.cost ?? "--"} GM
            </div>
          </div>
          <button
            type="button"
            className="rewards-list__modal-close"
            onClick={() => setSelectedReward(null)}
            aria-label={translate("v2_rewards_modal_close", lang)}
          >
            ×
          </button>
        </div>

        <div className="rewards-list__modal-body">
          {selectedReward.description ? (
            <p className="rewards-list__modal-text">{selectedReward.description}</p>
          ) : (
            <p className="rewards-list__modal-text rewards-list__modal-text--muted">
              {translate("v2_rewards_modal_no_description", lang)}
            </p>
          )}

          {selectedReward.rwType === "EAU" && (
            <div className="rewards-list__modal-meta">
              {translate("v2_rewards_modal_volume", lang)} <strong>{selectedReward.waterVolume ?? 0} L</strong>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RewardsDetailsModal;
